export function checkUserPermission (state, getters) {
  return (permission, allperms = true) => {
    if (permission.constructor === Array) {
      for (var perm of permission) {
        if (getters.checkUserPermission(perm) === false && allperms) {
          return false
        }
        if (getters.checkUserPermission(perm) === true && !allperms) {
          return true
        }
      }

      return allperms === true
    }

    if (
      permission === 'Admin' &&
      state.user &&
      state.user.roles.some((role) => {
        return role.name === 'Admin'
      })) {
      return true
    }

    if (!state || !state.user || !state.user.roles) {
      return false
    }

    return state.user.roles.some(role => {
      return role.permissions.indexOf(permission) >= 0
    })
  }
}
